import { Box } from '@mui/material'
import { styled } from '@mui/material/styles'

export const StyledCourseName = styled(Box)(({ theme }) => ({
  fontFamily: 'Inter',
  fontWeight: '700',
  fontSize: '15px',
  lineGeight: '100%',
  letterSpacing: '0%',

  [theme.breakpoints.down('md')]: {
    '> .MuiDialog-container > .MuiPaper-root': {
      margin: '0px',
      width: '90%'
    }
  }
}))
